import { Dialog, Button } from '@mui/material';

interface BottomOneBtnDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  btnText?: string;
  onClick?: () => void;
}

export default function BottomOneBtnDialog({
  open,
  onClose,
  title = '',
  description = '',
  btnText = '확인',
  onClick = () => {},
}: BottomOneBtnDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'flex-end',
        },
        '& .MuiPaper-root': {
          margin: '0 0 20px 0',
          borderRadius: '16px',
        },
      }}
    >
      <div className="flex flex-col p-6 gap-2 justify-between w-full text-base font-[600] text-[18px] leading-6 text-center text-white bg-white">
        <div className="text-[#000] font-[700] text-[20px] text-left">{title}</div>
        <div className="text-[#363636] text-left font-[400] text-[16px] mb-2">
          {description?.includes('\n')
            ? description?.split('\n').map((line, index) => (
                <div key={index} className="leading-[20px] text-[14px]">
                  {' '}
                  {line}
                </div>
              ))
            : description}
        </div>
        <Button variant="outlined" onClick={onClick}>
          {btnText}
        </Button>
      </div>
    </Dialog>
  );
}
